import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  Grid,
  Select,
  MenuItem,
  FormControl,
  Switch,
  CardContent,
  Tooltip,
} from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { images } from "../../../config";
import "../../../components/BPCL/BPCLGeneration/BPCLGeneration.css";
import { GenerationBarChart } from "../../Graph/BPCL/Generation-bar-chart";
import { GenerationDonutChart } from "../../Graph/BPCL/Generation-pie-chart";
import { useParams } from "react-router-dom";
import { getPlantProcessDashboardWeatherPeakData } from "../../../container/BPCL/services";
import Mqqtdata from "../../../container/ProcessDashboard/Mqqtdata";
import { SoftTagFormula } from "../../../container/SmartTag/softTag/SoftTagFormula";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { getLabels } from "../BPCL_labels";
import HalfCircleGauge from "../../Graph/BPCL/Speedometer";
import Datepicker2 from "../Datepicker/Datepicker2";
import Datepicker from "../Datepicker/Datepicker";

// Chart options
const chartOptions = {
  chart: {
    type: "column",
  },
  title: {
    text: "",
  },
  xAxis: {
    categories: ["06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00"],
  },
  credits: {
    enabled: false,
  },
  series: [
    {
      name: "MWh",
      data: [3000, 4000, 5000, 6000, 7000, 8000, 9000],
      color: "#9C27B0",
    },
  ],
};
const label = { inputProps: { "aria-label": "Switch demo" } };

const donutChartOptions = {
  chart: {
    type: "pie",
    options3d: {
      enabled: true,
      alpha: 45,
      beta: 0,
    },
  },
  credits: {
    enabled: false,
  },
  title: {
    text: "72%",
    align: "center",
    verticalAlign: "middle",
    y: 20,
    style: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#000",
    },
  },
  plotOptions: {
    pie: {
      innerSize: "70%",
      dataLabels: {
        enabled: false,
      },
    },
  },
  series: [
    {
      name: "Data",
      data: [
        { name: "Category A", y: 55 },
        { name: "Category B", y: 45 },
      ],
    },
  ],
};

const BPCLGeneration = (props) => {
  const [showGenerationAverage, setShowGenerationAverage] = useState(false);
  const [ACValue, setACValue] = useState();
  const [DCValue, setDCValue] = useState();

  const mqttDataReduce = props.mergedArray.reduce((map, item) => {
    map[item.device_tag] = Number(item.tagValue);
    return map;
  }, {});

  const tag = props.weatherGraphData[0];
  const tag1 = props.weatherGraphData[1];
  const tag2 = props.weatherGraphData[2];
  const tag3 = props.weatherGraphData[3];

  // console.log("props.generationData", props.generationData);

  const params = useParams();
  // console.log("props.generationDateWiseData", props.generationDateWiseData);

  let tagValue = props.mergedArray.length
    ? props.mergedArray.find(
        (f) =>
          f.device__uid === tag?.device_uid && f.device_tag === tag.device_tag
      )?.["tagValue"] || 0.0
    : 0.0;

  if (
    tag?.is_soft_tag &&
    tag?.soft_tag_id__formula &&
    Object.keys(mqttDataReduce).length
  ) {
    const softTagFormulaResult = SoftTagFormula(
      tag.soft_tag_id__formula,
      mqttDataReduce
    );
    if (softTagFormulaResult?.softTagNotGetTag) {
      tagValue = softTagFormulaResult.value;
    }
  }

  let tagValue1 = props.mergedArray.length
    ? props.mergedArray.find(
        (f) =>
          f.device__uid === tag1?.device_uid && f.device_tag === tag1.device_tag
      )?.["tagValue"] || 0.0
    : 0.0;

  if (
    tag1?.is_soft_tag &&
    tag1?.soft_tag_id__formula &&
    Object.keys(mqttDataReduce).length
  ) {
    const softTagFormulaResult = SoftTagFormula(
      tag1.soft_tag_id__formula,
      mqttDataReduce
    );
    if (softTagFormulaResult?.softTagNotGetTag) {
      tagValue = softTagFormulaResult.value;
    }
  }

  let tagValue2 = props.mergedArray.length
    ? props.mergedArray.find(
        (f) =>
          f.device__uid === tag2?.device_uid && f.device_tag === tag2.device_tag
      )?.["tagValue"] || 0.0
    : 0.0;

  if (
    tag2?.is_soft_tag &&
    tag2?.soft_tag_id__formula &&
    Object.keys(mqttDataReduce).length
  ) {
    const softTagFormulaResult = SoftTagFormula(
      tag2.soft_tag_id__formula,
      mqttDataReduce
    );
    if (softTagFormulaResult?.softTagNotGetTag) {
      tagValue = softTagFormulaResult.value;
    }
  }

  let tagValue3 = props.mergedArray.length
    ? props.mergedArray.find(
        (f) =>
          f.device__uid === tag3?.device_uid && f.device_tag === tag3.device_tag
      )?.["tagValue"] || 0.0
    : 0.0;

  if (
    tag3?.is_soft_tag &&
    tag3?.soft_tag_id__formula &&
    Object.keys(mqttDataReduce).length
  ) {
    const softTagFormulaResult = SoftTagFormula(
      tag3.soft_tag_id__formula,
      mqttDataReduce
    );
    if (softTagFormulaResult?.softTagNotGetTag) {
      tagValue = softTagFormulaResult.value;
    }
  }

  let ActivePowerValue;

  if (params.id != 58 || params.id != 59) {
    ActivePowerValue = props.mergedArray.length
      ? props.mergedArray.find(
          (f) =>
            f.device__uid === props.acValue[0]?.device_uid &&
            (f.device_tag === props.acValue[0]?.device_tag ||
              f.device_tag === null)
        )?.["tagValue"] || 0.0
      : 0.0;

    if (
      props.acValue[0]?.is_soft_tag &&
      props.acValue[0]?.soft_tag_id__formula
    ) {
      const softTagResult = SoftTagFormula(
        props.acValue[0]?.soft_tag_id__formula,
        mqttDataReduce
      );

      console.log("softTagResult", softTagResult);

      if (softTagResult?.softTagNotGetTag) {
        ActivePowerValue = softTagResult?.value;
      }
    }
  } else {
    ActivePowerValue = props.mergedArray.length
      ? props.mergedArray.find(
          (f) =>
            f.device__uid === tag.device_uid &&
            (f.device_tag === tag.device_tag || f.device_tag === null)
        )?.["tagValue"] || 0.0
      : 0.0;

    if (tag?.is_soft_tag && tag?.soft_tag_id__formula) {
      const softTagResult = SoftTagFormula(
        tag?.soft_tag_id__formula,
        mqttDataReduce
      );

      console.log("softTagResult", softTagResult);

      if (softTagResult?.softTagNotGetTag) {
        ActivePowerValue = softTagResult?.value;
      }
    }
  }

  const findStatus = props.tagStatus1.length
    ? props.tagStatus1.find((f) => f.dvName == tag?.device_tag)
    : 0;

  const formattedTagValue =
    typeof tagValue === "number" &&
    tagValue % 1 !== 0 &&
    tagValue !== 0 &&
    tagValue !== 1
      ? tagValue.toFixed(5)
      : tagValue || tagValue;

  const formattedTagValue1 =
    typeof tagValue === "number" &&
    tagValue1 % 1 !== 0 &&
    tagValue1 !== 0 &&
    tagValue1 !== 1
      ? tagValue1.toFixed(5)
      : tagValue1 || tagValue1;

  const formattedTagValue2 =
    typeof tagValue2 === "number" &&
    tagValue2 % 1 !== 0 &&
    tagValue2 !== 0 &&
    tagValue2 !== 1
      ? tagValue2.toFixed(5)
      : tagValue2 || tagValue2;

  const formattedTagValue3 =
    typeof tagValue3 === "number" &&
    tagValue3 % 1 !== 0 &&
    tagValue3 !== 0 &&
    tagValue3 !== 1
      ? tagValue3.toFixed(5)
      : tagValue3 || tagValue3;

  const labels = getLabels(props.generationTime);

  useEffect(() => {
    let totalDCValue = 0;

  
    const updatedDCValues = props.DCValues.map((dc) => {
      let DCLiveValue = 0.0;
  
      // Find the matching value from mergedArray
      if (props.mergedArray.length) {
        DCLiveValue = Number(
          props.mergedArray.find(
            (f) =>
              f.device__uid === dc.device_uid && f.device_tag === dc.device_tag
          )?.["tagValue"] || 0.0
        );
      }
  

  
      // If it's a soft tag, apply the formula
      if (
        dc?.is_soft_tag &&
        dc?.soft_tag_id__formula &&
        Object.keys(mqttDataReduce).length
      ) {
        const softTagFormulaResult = SoftTagFormula(
          dc.soft_tag_id__formula,
          mqttDataReduce
        );
        console.log(
          "Soft Tag Formula Result:",
          dc,
          softTagFormulaResult,
          mqttDataReduce
        );
  
        if (softTagFormulaResult?.softTagNotGetTag) {
          DCLiveValue = Number(softTagFormulaResult.value);
        }
      }
  
      return { ...dc, DCLiveValue };
    });
  
    // Remove old values and add new values
    totalDCValue = updatedDCValues.reduce((sum, dc) => {
      let value = dc.DCLiveValue;
  
      if (params.id == 58) {
        value = dc.DCLiveValue / 1000;
      }
  
      if (params.id == 59) {
        value = dc.DCLiveValue / 1000;
      }
  
      return sum + value;
    }, 0);
  
    // Set the total summed value
    setDCValue(totalDCValue);
    setACValue(ActivePowerValue);
  
    const peakValue = tag?.peak_value_today;
  }, [tag, props.acValue, props.DCValue, props.mergedArray]);
  

  return (
    <Box className="pt-2">
      <Card className="availability-box">
        {/* <div>
          <div
            className="typography_Growth mb-3 highlight-title"
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "8px 12px", // Adjust padding
              borderRadius: "4px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                display: "inline-block",
                whiteSpace: "nowrap",
                marginRight: "15px", // Space between text and image
              }}
            >
              <b>
                {params.id == 56
                  ? "18MWp DC / 14MW AC SOLAR PLANT AT BINA REFINERY IN MP"
                  : params.id == 57
                    ? "8.40MWp DC / 6MW AC SOLAR PLANT BEHIND BPCL CISF COLONY, KOCHI IN KERALA"
                    : params.id == 58
                      ? "4.60MWp DC / 3.37MW AC SOLAR PLANT AT RWH, KOCHI IN KERALA"
                      : params.id == 59
                        ? "5.20MWp DC / 3.82MW AC SOLAR PLANT AT STF, KOCHI IN KERALA"
                        : ""}
              </b>
            </Typography>
            <Tooltip
              title={
                params.id == 56
                  ? "18MWp DC / 14MW"
                  : params.id == 57
                    ? "8.40MWp DC / 6MW"
                    : params.id == 58
                      ? "4.60MWp DC / 3.37MW"
                      : params.id == 59
                        ? "5.20MWp DC / 3.82MW"
                        : ""
              }
              arrow
            >
              <img
                src={images.infoIconBlack}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
                alt=""
              />
            </Tooltip>
          </div>
        </div> */}

        <Typography
          variant="h6"
          className="typography_Growth mb-3"
          style={{ fontWeight: "600" }}
        >
          Generation {"( "}
          <span style={{ color: "#55BF3B" }}>
            {" "}
            {isNaN(DCValue) ? "0.00" : Number(DCValue).toFixed(2)}{" "}
          </span>
          <span style={{ color: "#000000" }}>MW DC</span> /{" "}
          <span style={{ color: "#55BF3B" }}>
            {isNaN(ACValue) ? "0.00" : Number(ACValue).toFixed(2)}{" "}
          </span>
          {/* <span style={{ color: "#000000" }}>{tag?.tag_unit} AC</span> /{" "} */}
          <span style={{ color: "#000000" }}>MW AC</span> {" )"}
        </Typography>

        <Grid container spacing={2} className="custom-grid mt-3 mb-3">
          <Grid item xs={12} sm={12} md={3}>
            <div className="card_weather">
              <div>
                {" "}
                <h5 className="weather_BPCL">Active Power</h5>
              </div>
              <div className="weather-card-data">
                {" "}
                {tag && Object.keys(tag).length > 0 ? (
                  <HalfCircleGauge
                    realTimeData={tag}
                    sliderRealTimeTagData={props.mergedArray}
                    containerName={"guage_7"}
                    color={"red-green"}
                  />
                ) : (
                  <img
                    src={images.noDataFoundImg}
                    className="notFoundDataImg"
                    alt="No Data Found Img"
                    style={{ transform: "translate(-16px, -8px)" }}
                  />
                )}
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={3}>
            <div className="card_weather">
              <div>
                <h5 className="weather_BPCL">Reactive Power</h5>
              </div>
              <div className="weather-card-data">
                {tag1 && Object.keys(tag1).length > 0 ? (
                  <HalfCircleGauge
                    realTimeData={tag1}
                    sliderRealTimeTagData={props.mergedArray}
                    containerName={"guage_8"}
                    color={"green-red"}
                  />
                ) : (
                  <img
                    src={images.noDataFoundImg}
                    className="notFoundDataImg"
                    alt="No Data Found Img"
                    style={{ transform: "translate(-16px, -8px)" }}
                  />
                )}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <div className="card_weather">
              <div>
                {" "}
                <h5 className="weather_BPCL">CUF</h5>
              </div>
              <div className="weather-card-data">
                {tag2 && Object.keys(tag2).length > 0 ? (
                  <HalfCircleGauge
                    realTimeData={tag2}
                    sliderRealTimeTagData={props.generationCurrentData}
                    containerName={"guage_9"}
                    color={"red-green"}
                    label="CUF"
                  />
                ) : (
                  <img
                    src={images.noDataFoundImg}
                    className="notFoundDataImg"
                    alt="No Data Found Img"
                    style={{ transform: "translate(-16px, -8px)" }}
                  />
                )}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <div className="card_weather">
              <div>
                {" "}
                <h5 className="weather_BPCL">PR</h5>
              </div>
              <div className="weather-card-data">
                {tag3 && Object.keys(tag3).length > 0 ? (
                  <HalfCircleGauge
                    realTimeData={tag3}
                    sliderRealTimeTagData={props.generationCurrentData}
                    containerName={"guage_10"}
                    color={"red-green"}
                    label="PR"
                  />
                ) : (
                  <img
                    src={images.noDataFoundImg}
                    className="notFoundDataImg"
                    alt="No Data Found Img"
                    style={{ transform: "translate(-16px, -8px)" }}
                  />
                )}
              </div>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={5}>

          <Grid item xs={12}>
            <Box>
              <Grid container spacing={3}>
                {/* Dropdowns */}

                <Grid item xs={12} md={12} >
                  {/* Chart Title and Selectors */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 2,
                      gap: "10px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="d-flex gap-2">
                      <div>
                        <FormControl fullWidth variant="outlined" size="small">
                          <Select
                            value={props.generationValue}
                            onChange={props.handleDateGenerationValue}
                            className="amb_BPCL"
                          >
                            <MenuItem value={1}>Generation</MenuItem>
                            <MenuItem value={2}>PR</MenuItem>
                            <MenuItem value={3}>CUF</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      {/* <Typography variant="h6">AGG</Typography> */}
                      <div className="average_buttons">
                        <h6 className="average">Average</h6>
                        <Switch
                          className="averagebuttons"
                          checked={showGenerationAverage}
                          onChange={(e) =>
                            setShowGenerationAverage(e.target.checked)
                          }
                        />
                        <b>
                          {showGenerationAverage
                            ? props.generationData?.overall_average_value
                            : ""}
                        </b>
                        <h6 className="average-rate">
                          {showGenerationAverage
                            ? props.generationData?.tag_unit
                            : ""}
                        </h6>
                      </div>
                      <Datepicker
                        startDate={props.generationStartDate}
                        endDate={props.generationEndDate}
                        setStartDate={props.setGenerationStartDate}
                        setEndDate={props.setGenerationEndDate}
                      />
                    </div>
                    <div>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        className="d-flex flex-row gap-2"
                      >
                        <Select
                          value={props.generationTime}
                          onChange={props.handleDateGenerationTime}
                          className="inpute-week"
                          // sx={{ padding: "1.7rem 0" }}
                        >
                          <MenuItem value={1}>Today</MenuItem>
                          <MenuItem value={2}>Week</MenuItem>
                          <MenuItem value={3}>Month</MenuItem>
                          <MenuItem value={4}>Quarter</MenuItem>
                          <MenuItem value={5}>Year</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={2} className="mt-5">
                {/* Main Chart */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  style={{ borderRight: "1px solid #f5efef" }}
                >
                  <GenerationBarChart
                    generationData={
                      props.generationStartDate && props.generationEndDate
                        ? props.generationDateWiseData
                        : props.generationData
                    }
                    showGenerationAverage={showGenerationAverage}
                    startDate={props.generationStartDate}
                    endDate={props.generationEndDate}
                    generationTime={props.generationTime}
                  />
                </Grid>

                {/* Secondary Donut Chart */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={3}
                 
                  style={{ borderRight: "1px solid #f5efef" }}
                >
                  <GenerationDonutChart
                    className="genrationdunut"
                    generationData={props.generationData}
                    labels={labels}
                  />
                </Grid>

                {/* Metrics Section */}
                <Grid item xs={12} sm={12} md={3} style={{marginTop:"-74px"}}>
                  <Box>
                    <h6 className="mt-1 invertersgenration">Generation</h6>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6}>
                        <button className="BPCLavailability1">
                          <h3
                            className="bpclPlant labelOne"
                            style={{ color: "black" }}
                          >
                            {labels.labelOne}
                          </h3>
                          <div className="d-flex flex-availbility">
                            <h3
                              className="plant_time"
                              style={{ color: "black" }}
                            >
                              {
                                props.generationBoxData?.generation
                                  ?.current_difference
                              }
                            </h3>
                            <span
                              className="plant_hrs"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.generation?.current_tag_unit}
                            </span>
                          </div>
                        </button>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <button className="BPCLavailability1">
                          <h3
                            className="bpclPlant labelTwo"
                            style={{ color: "black" }}
                          >
                            {labels.labelTwo}
                          </h3>
                          <div className="d-flex flex-availbility">
                            <h3
                              className="plant_time"
                              style={{ color: "black" }}
                            >
                              {
                                props.generationBoxData?.generation
                                  ?.past_difference
                              }
                            </h3>
                            <span
                              className="plant_hrs"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.generation?.past_tag_unit}
                            </span>
                          </div>
                        </button>
                      </Grid>
                    </Grid>

                    <h6 className="mt-4">PR</h6>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <button className="BPCLavailability1">
                          <h3
                            className="bpclPlant labelOne"
                            style={{ color: "black" }}
                          >
                            {labels.labelOne}
                          </h3>
                          <div className="d-flex flex-availbility">
                            <h3
                              className="plant_time"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.pr?.current_avg}
                            </h3>
                            <span
                              className="plant_hrs"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.pr?.tag_unit}
                            </span>
                          </div>
                        </button>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <button className="BPCLavailability1">
                          <h3
                            className="bpclPlant labelTwo"
                            style={{ color: "black" }}
                          >
                            {labels.labelTwo}
                          </h3>
                          <div className="d-flex flex-availbility">
                            <h3
                              className="plant_time"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.pr?.past_avg}
                            </h3>
                            <span
                              className="plant_hrs"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.pr?.tag_unit}
                            </span>
                          </div>
                        </button>
                      </Grid>
                    </Grid>

                    <h6 className="mt-4">CUF</h6>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <button className="BPCLavailability1">
                          <h3
                            className="bpclPlant labelOne"
                            style={{ color: "black" }}
                          >
                            {labels.labelOne}
                          </h3>
                          <div className="d-flex flex-availbility">
                            <h3
                              className="plant_time"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.cuf?.current_avg}
                            </h3>
                            <span
                              className="plant_hrs"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.cuf?.tag_unit}
                            </span>
                          </div>
                        </button>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <button className="BPCLavailability1">
                          <h3
                            className="bpclPlant labelTwo"
                            style={{ color: "black" }}
                          >
                            {labels.labelTwo}
                          </h3>
                          <div className="d-flex flex-availbility">
                            <h3
                              className="plant_time"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.cuf?.past_avg}
                            </h3>
                            <span
                              className="plant_hrs"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.cuf?.tag_unit}
                            </span>
                          </div>
                        </button>
                      </Grid>
                    </Grid>

                    <h6 className="mt-4">Radiation</h6>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <button className="BPCLavailability1">
                          <h3
                            className="bpclPlant labelOne"
                            style={{ color: "black" }}
                          >
                            {labels.labelOne}
                          </h3>
                          <div className="d-flex flex-availbility">
                            <h3
                              className="plant_time"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.plant_gti?.current_avg}
                            </h3>
                            <span
                              className="plant_hrs"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.plant_gti?.tag_unit}
                            </span>
                          </div>
                        </button>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <button className="BPCLavailability1">
                          <h3
                            className="bpclPlant labelTwo"
                            style={{ color: "black" }}
                          >
                            {labels.labelTwo}
                          </h3>
                          <div className="d-flex flex-availbility">
                            <h3
                              className="plant_time"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.plant_gti?.past_avg}
                            </h3>
                            <span
                              className="plant_hrs"
                              style={{ color: "black" }}
                            >
                              {props.generationBoxData?.plant_gti?.tag_unit}
                            </span>
                          </div>
                        </button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

export default BPCLGeneration;